import { CircleSlash, Itsme, Keyboard, QRCode } from '@frontend/icons';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage, useIntl } from 'react-intl';

import { MethodButton } from '../../components/method-button/method-button';
import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import useDropOffMethod from './drop-off-method.controller';

const ID = 'drop-off-method';

const DropOffMethod = () => {
    const intl = useIntl();
    const viewProps = useDropOffMethod();

    return (
        <WizardScreenContainer
            id={ID}
            header={{ title: CommonMessage.BUTTONS.DROP_OFF }}>
            <div className='text-always-black w-full text-base font-medium'>
                <FormattedMessage
                    id='kiosk.wizard.drop-off-method.instructions'
                    description='Instructions for drop-off method selection'
                    defaultMessage='Please choose one of the options to continue your drop-off'
                />
            </div>

            <div className='flex flex-col items-start justify-start gap-2 self-stretch'>
                {viewProps.pinStep && (
                    <MethodButton
                        label={intl.formatMessage({
                            defaultMessage: 'Input PIN-code',
                            id: 'kiosk.wizard.drop-off-method.input-pin',
                            description: 'Label for button to input PIN-code manually'
                        })}
                        icon={<Keyboard className='text-always-black size-5' />}
                        onClick={() => viewProps.onContinue(viewProps.pinStep)}
                    />
                )}
                {viewProps.scanStep && (
                    <MethodButton
                        label={intl.formatMessage({
                            defaultMessage: 'Scan QR-code',
                            id: 'kiosk.wizard.drop-off-method.scan-qr',
                            description: 'Label for button to scan QR code'
                        })}
                        icon={<QRCode className='text-always-black size-5' />}
                        onClick={() => viewProps.onContinue(viewProps.scanStep)}
                    />
                )}
                {viewProps.itsmeStep && (
                    <MethodButton
                        label={intl.formatMessage({
                            defaultMessage: 'Login with itsme',
                            id: 'kiosk.wizard.method-select.login-itsme',
                            description: 'Label for button to login with itsme'
                        })}
                        icon={<Itsme className='text-always-black size-5' />}
                        onClick={() => viewProps.onContinue(viewProps.itsmeStep)}
                    />
                )}
                {viewProps.falseStep && (
                    <MethodButton
                        label={intl.formatMessage({
                            defaultMessage: 'Continue without a code',
                            id: 'kiosk.wizard.drop-off-method.continue-without-code',
                            description: 'Label for button to continue without a code'
                        })}
                        trailingLabel={intl.formatMessage({
                            defaultMessage: 'Open Drop-off',
                            id: 'kiosk.wizard.drop-off-method.open-drop-off-badge',
                            description: 'Outlined badge on the continue-without-a-code button indicating Open Drop-off'
                        })}
                        icon={<CircleSlash className='text-always-black size-5' />}
                        onClick={() => viewProps.onOpenDropoff()}
                    />
                )}
            </div>
        </WizardScreenContainer>
    );
};

export default DropOffMethod;
